export default "__VITE_ASSET__59d1689c__"